import EmblaCarousel from "embla-carousel";

function setupButtons(embla, root) {
  const prevBtn = root.querySelector("[data-embla-prev]");
  const nextBtn = root.querySelector("[data-embla-next]");

  const updateButtons = () => {
    const canPrev = embla.canScrollPrev();
    const canNext = embla.canScrollNext();
    // Hide the arrows entirely when there is nothing to scroll (e.g. a single
    // slide, or all slides already fit). Uses the `hidden` utility class so it
    // wins over the button's `inline-flex` component style.
    const scrollable = canPrev || canNext;

    if (prevBtn) {
      prevBtn.disabled = !canPrev;
      prevBtn.classList.toggle("hidden", !scrollable);
    }
    if (nextBtn) {
      nextBtn.disabled = !canNext;
      nextBtn.classList.toggle("hidden", !scrollable);
    }
  };

  if (prevBtn) prevBtn.addEventListener("click", () => embla.scrollPrev());
  if (nextBtn) nextBtn.addEventListener("click", () => embla.scrollNext());

  embla.on("select", updateButtons);
  embla.on("init", updateButtons);
  embla.on("reInit", updateButtons);
  updateButtons();
}

export function initEmblaCarousel(root) {
  if (root.dataset.emblaInit) return;
  root.dataset.emblaInit = "true";

  const viewport = root.querySelector(".embla__viewport");
  if (!viewport) return;

  const embla = EmblaCarousel(viewport, {
    loop: false,
    slidesToScroll: "auto",
  });

  setupButtons(embla, root);
}

export function initEmblaCarouselGallery(root) {
  if (root.dataset.emblaInit) return;
  root.dataset.emblaInit = "true";

  const viewport = root.querySelector(".embla__viewport");
  if (!viewport) return;

  const embla = EmblaCarousel(viewport, {
    slidesToScroll: "auto",
  });

  setupButtons(embla, root);
}
